import axios from "axios";
import Cookies from "js-cookie";

const apiUrl = process.env.REACT_APP_API_URL || window.location.origin;

const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Tell the API which language the site is displayed in, so success and
// validation messages come back in that language.
apiClient.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = Cookies.get("i18next") || "ar";
  return config;
});

export default apiClient;
